module.exports = __webpack_public_path__ + "img/aej1n-66wvl.016.80da0f56.png";